var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.743,
    height: 34.995,
    viewBox: "0 0 43.743 34.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71b6f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.943,25.469l4.785-4.785a2.188,2.188,0,0,0-.877-3.629l-2.856-.918V6.561a2.187,2.187,0,0,0-2.187-2.187H28.433V1.64A1.64,1.64,0,0,0,26.793,0H16.951a1.64,1.64,0,0,0-1.64,1.64V4.374H10.936A2.187,2.187,0,0,0,8.749,6.561v9.576l-2.856.918a2.188,2.188,0,0,0-.877,3.629L9.8,25.469C8.6,28.453,5.85,30.62,1.64,30.62A1.64,1.64,0,0,0,0,32.261v1.094a1.64,1.64,0,0,0,1.64,1.64,12.606,12.606,0,0,0,9.792-4.06,6.572,6.572,0,0,0,6.065,4.06h8.749a6.572,6.572,0,0,0,6.065-4.06,12.606,12.606,0,0,0,9.792,4.06,1.64,1.64,0,0,0,1.64-1.64V32.261a1.64,1.64,0,0,0-1.64-1.64C37.946,30.62,35.163,28.5,33.943,25.469ZM13.123,8.749h17.5v5.983l-8.079-2.6a2.187,2.187,0,0,0-1.339,0l-8.079,2.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipSolid);
export default __webpack_public_path__ + "static/media/ship-solid.1007dd88018b105cbfec5a40dbc13ae5.svg";
export { ForwardRef as ReactComponent };